import React from "react";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import BlockIcon from "@mui/icons-material/Block";
import StarIcon from "@mui/icons-material/Star";
import { DESIGN_TOKENS, ORDER_RANKING } from "../../../../types/order";

const OrderPriorityIndicator = ({
  orderIndex,
  isBlacklisted,
  rankingByTotal,
  badgeColor,
  theme,
  isMobile = false,
  onClick,
  isClickable = false,
  isSelected = false,
}) => {
  const size = isMobile
    ? DESIGN_TOKENS.avatarSize.sm
    : DESIGN_TOKENS.avatarSize.md;
  const fontSize = isMobile
    ? DESIGN_TOKENS.fontSize.base
    : DESIGN_TOKENS.fontSize.lg;
  const iconSize = isMobile ? 10 : 14;

  const borderStyle = isBlacklisted
    ? `2px solid ${theme.palette.error.main}`
    : `1px solid ${alpha(badgeColor, 0.3)}`;

  const showSpecialStar = rankingByTotal === ORDER_RANKING.SPECIAL && isMobile;

  const content = (
    <>
      {isBlacklisted && <BlockIcon sx={{ fontSize: iconSize }} />}
      <Typography sx={{ fontSize, fontWeight: 700 }}>{orderIndex}</Typography>
      {showSpecialStar && (
        <StarIcon sx={{ fontSize: iconSize, ml: 0.3, color: "#DAA520" }} />
      )}
    </>
  );

  return (
    <Box
      onClick={isClickable ? onClick : undefined}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: isSelected ? alpha(badgeColor, 0.3) : alpha(badgeColor, 0.15),
        color: badgeColor,
        borderRadius: DESIGN_TOKENS.borderRadius.md,
        p: isMobile ? 0.6 : 0.75,
        minWidth: size,
        height: size,
        fontWeight: 700,
        border: borderStyle,
        cursor: isClickable ? "pointer" : "default",
        transition: "all 0.2s ease-in-out",
        "&:hover": isClickable
          ? {
              bgcolor: alpha(badgeColor, 0.25),
              transform: "scale(1.05)",
            }
          : {},
      }}
      role="status"
      aria-label={`Pedido número ${orderIndex}${
        isBlacklisted ? ", cliente não confiável" : ""
      }${isSelected ? ", selecionado para despacho" : ""}`}
    >
      <Stack direction="row" alignItems="center" spacing={0.3}>
        {content}
      </Stack>
    </Box>
  );
};

export default React.memo(OrderPriorityIndicator);
